import * as swcHelpers from '@swc/helpers';
import { liteClient } from 'algoliasearch/lite';

function queryAlgolia(algoliaConfig, searchOptions) {
    return _queryAlgolia.apply(this, arguments);
}
function _queryAlgolia() {
    _queryAlgolia = swcHelpers.asyncToGenerator(function*(algoliaConfig, searchOptions) {
        const { apiKey , appId , indexName  } = algoliaConfig;
        if (!apiKey || !appId || !indexName) {
            console.error(`[queryAlgolia]: missing ApiKey: ${apiKey}, AppId:  ${appId} or indexName : ${indexName} `);
            return null;
        }
        /**
   * Initialize search client and index
   */ const client = liteClient(appId, apiKey);
        try {
            var _query;
            const result = yield client.search({
                requests: [
                    swcHelpers.objectSpread({
                        query: (_query = searchOptions.query) !== null && _query !== void 0 ? _query : '',
                        indexName
                    }, searchOptions), 
                ]
            });
            return result.results[0];
        } catch (error) {
            console.error(`[queryAlgolia]: Something went wrong searching Algolia.`, error);
            return null;
        }
    });
    return _queryAlgolia.apply(this, arguments);
}

export { queryAlgolia };
//# sourceMappingURL=query-algolia.js.map
